/* eslint-disable import/no-cycle */

import { SagaIterator } from 'redux-saga';
import { takeLatest, put, select, StrictEffect } from 'redux-saga/effects';
import { IAccount } from 'src/types/login';
import i18n from 'src/i18n';
import { validateToken, updateToken } from '../../api/api';
import { AccountTokensResult, unavailableAccountsMessage, updateAccountTokens } from '../../api/accountTokens';
import { LoginActionType } from '../actions/actionType';
import * as actions from '../actions/loginAction';
import { ILoginState, PrivacyPolicy } from '../type';
import { IRootReducer } from '../reducers';
import { setIsRedirectPopupOpenAction } from '../slices/common/commonSlice';

// interface IRes {
//     response: string;
//     data: object;
//     autoLogin: string;
// }
export interface IContactLoginData {
    fcAccounts: IAccount[];
    gps_token: string;
    token: string;
    userUUID: string;
    indexerR?: string;
    logLevelCode?: string;
}
/*  set validateToken and update token */

export interface IValidateTokenResData {
    autoLogin: '1' | '2' | '3' | '4';
    data: IContactLoginData[];
    response: '0' | '1' | '99';
    proxyUrl?: string;
}

export interface IValidateTokenResDataWithPrivacyPolicy {
    autoLogin: '1' | '2' | '3' | '4';
    response: '5';
    data: PrivacyPolicy;
}

export type ValidateTokenResponse = IValidateTokenResData | IValidateTokenResDataWithPrivacyPolicy;

export function* initConnect({ payload }: Partial<{ payload: { deviceToken: string }; type: string }>): any {
    try {
        if (!payload || !payload.deviceToken) {
            yield put(actions.initConnectFail({}));
            return;
        }

        const response = yield validateToken({
            deviceToken: payload?.deviceToken,
        });

        const { data = {}, status } = response;

        if (data?.response === '5' && status === 200) {
            const privacyPolicy: PrivacyPolicy = data.data;

            yield put(actions.setPrivacyPolicy(privacyPolicy));
            yield put(actions.setNeedsPrivacyPolicy(true));
            yield put(actions.initConnectFail({}));
            return;
        }
        const resData: IValidateTokenResData = data;

        if (data?.response === '0' && status === 200) {
            yield put(actions.setNeedsPrivacyPolicy(false));

            const loginData: IContactLoginData = resData?.data[0] || {};
            const fcAccounts: IAccount[] = loginData.fcAccounts || [];
            const token: string = loginData.token || '';
            const indexerR: string = loginData.indexerR || '';
            const rootProxyUrl: string = resData?.proxyUrl || '';

            const { available, unavailable }: AccountTokensResult = yield updateAccountTokens(
                fcAccounts,
                ({ proxyUrl, contactUUID, dbUrl, proxyToken }) =>
                    updateToken({
                        token,
                        proxyUrl,
                        dbUrl,
                        contactUUID,
                        indexerR,
                        accessToken: proxyToken?.accessToken || '',
                        tokenType: proxyToken?.tokenType || 'Bearer',
                    })
            );

            if (fcAccounts.length && !available.length) {
                yield put(actions.initConnectFail({}));
                return;
            }
            if (unavailable.length) {
                yield put(actions.setErrorMessage(unavailableAccountsMessage(unavailable, i18n.t.bind(i18n))));
            }

            yield put(
                actions.initConnectSuccess({
                    ...loginData,
                    fcAccounts: available,
                    loginType: Number(resData?.autoLogin),
                    proxyUrl: rootProxyUrl,
                })
            );
        } else {
            yield put(actions.initConnectFail({}));
        }
    } catch (error: any) {
        console.log(error);
        if (error?.response?.status === 401) {
            const selectedFcAccount = yield select((state: IRootReducer) => state.loginReducer.selectedFcAccount);
            if (selectedFcAccount) {
                yield put(setIsRedirectPopupOpenAction({ isRedirectPopupOpen: true, reason: 'refresh_failed' }));
                return;
            }
        }
        yield put(actions.initConnectFail({}));
    }
}

function* initLogout({ payload }: Partial<{ payload: { token: string }; type: string }>): any {
    try {
        const response = yield validateToken({
            deviceToken: payload?.token || '',
        });
        const { data = {} } = response;

        // if (data?.response === '0') {
        //    console.log('initConnectSuccess data:', data);
        //    yield put(
        //       actions.initConnectSuccess({
        //          ...(data?.data[0] || {}),
        //          loginType: Number(data?.auoLogin),
        //       }),
        //    );
        // } else yield put(actions.initConnectFail({}));
    } catch (error) {
        console.log(error);

        yield put(actions.initConnectFail({}));
    }
}

export default function* loginSaga() {
    yield takeLatest(LoginActionType.initialConfiguration, initConnect);
    yield takeLatest(LoginActionType.Logout, initLogout);
}
